import { createStore } from 'vuex'

const flexDriveStore = createStore({
  state() {
    return {
      brands: [],
      models: [],
      fuels: [],
      transmissions: [],
      prices: [],
    }
  },
  mutations: {
    setField(state, payload) {
      state[payload.field] = payload.value
    },
  },
  getters: {
    getField: (state) => (field) => {
      return state[field]
    },
  },
})

export default flexDriveStore
